/**
 * 用户行为
 */
import http from './http'

export default class ActionApi {
    static asyncUpdate(params) {
        return http.httpPost('action/update', params);
    }

}


// WEBPACK FOOTER //
// ./app/api/action.api.js